import { PropTypes } from 'prop-types';
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { StandardButton, StandardButtonType } from '@payer-admin-ui/components-v2/src/buttons/StandardButton';

const ConfirmModal = ({ isOpen, title, onCancel, onConfirm, isFetching, isConfirmDisabled = false, children }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>{t(title)}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <StandardButton type={StandardButtonType.CANCEL} onClick={onCancel} />
        <StandardButton
          type={StandardButtonType.CONFIRM}
          onClick={onConfirm}
          disabled={isConfirmDisabled}
          loading={isFetching}
        />
      </ModalFooter>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  messageArguments: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  isFetching: PropTypes.bool,
  children: PropTypes.node,
  isConfirmDisabled: PropTypes.bool,
};

export { ConfirmModal };
